import { AegisClient } from "@nike/aegis-auth-react";
import { REACT_URL, IS_OKTA_QA } from "../constants/app.constants";

const aegisClient = new AegisClient({
  clientId: "nike.apla.node-ship2plan-react",
  redirectUri: REACT_URL,
  qa: IS_OKTA_QA,
});

export default aegisClient;
